import { render, staticRenderFns } from "./HistoryPopup.component.vue?vue&type=template&id=35447633&scoped=true&"
import script from "./HistoryPopup.component.vue?vue&type=script&lang=js&"
export * from "./HistoryPopup.component.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPopup.component.vue?vue&type=style&index=0&id=35447633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35447633",
  null
  
)

export default component.exports